import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import { getHistoryType } from '../actions/sharedActions';
import rootReducer from '../reducers/index';
import logger from '../middleware/logger';

export default function configureStore(initialState) {
  const { historyType } = getHistoryType();

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line
  const routesMiddleware = routerMiddleware(historyType);
  let middleware = [thunkMiddleware, routesMiddleware];

  // Add middleware for non-production environment
  if (process.env.NODE_ENV !== 'production') {
    middleware = [...middleware, logger];
  }

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware)),
  );

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers/index').default; // eslint-disable-line
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}
